/*
* Copyright (C) Regione Lombardia
*/
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PagesCmsAccessibilitaComponent } from './accessibilita/accessibilita.component';
import { PagesCmsComponent } from './cms/cms.component';
import { PagesCmsContattiComponent } from './contatti/contatti.component';
import { PagesCmsCookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { PagesCmsNoteLegaliComponent } from './note-legali/note-legali.component';
import { PagesCmsPrivacyComponent } from './privacy/privacy.component';
import { PagesCmsRedazioneComponent } from './redazione/redazione.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                component: PagesCmsComponent,
                children: [
                    { path: 'accessibilita', component: PagesCmsAccessibilitaComponent },
                    { path: 'contatti', component: PagesCmsContattiComponent },
                    { path: 'cookie-policy', component: PagesCmsCookiePolicyComponent },
                    { path: 'note-legali', component: PagesCmsNoteLegaliComponent },
                    { path: 'privacy', component: PagesCmsPrivacyComponent },
                    { path: 'redazione', component: PagesCmsRedazioneComponent },
                    { path: '**', redirectTo: 'accessibilita', pathMatch: 'full' },
                ]
            }
        ]),
    ],
    exports: [
        RouterModule,
    ]
})

export class PagesCmsRouting { }
